import { render, staticRenderFns } from "./OrganizationEventChip.vue?vue&type=template&id=27108884&scoped=true"
import script from "./OrganizationEventChip.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationEventChip.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrganizationEventChip.vue?vue&type=style&index=0&id=27108884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27108884",
  null
  
)

export default component.exports